import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, BriefcaseBusiness, CalendarClock, HeartHandshake, Mail, RotateCcw, ShieldCheck } from "lucide-react";
const highlights = [{
  title: "Meaningful Client Work",
  description: "Support First Nation communities and Northern organizations with financial reporting, program support, audit readiness, and practical follow-through that helps important files move forward.",
  icon: HeartHandshake
}, {
  title: "A Balanced Work Model",
  description: "RiverBend values sustainable workloads, clear priorities, and a more balanced approach that does not rely on excessive busy-season overtime as the norm.",
  icon: ShieldCheck
}, {
  title: "Room to Lead and Contribute",
  description: "Help coordinate work, solve practical reporting problems, support stronger systems, and contribute to better financial information for the communities and organizations we serve.",
  icon: BriefcaseBusiness
}];
export default function GolfCourse() {
  return <section data-section-id="261648" id="job-application-footer" className="bg-background text-foreground py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 xl:gap-12 items-stretch">
          <div className="lg:col-span-2 min-w-0">
            <Card className="h-full border-border shadow-sm rounded-lg overflow-hidden">
              <CardContent className="p-8 md:p-10">
                <p className="text-secondary font-default font-bold tracking-wider uppercase text-sm mb-4">
                  How to Apply
                </p>

                <h2 className="text-3xl md:text-4xl font-default font-bold text-primary-500 mb-5">
                  Interested in this role?
                </h2>

                <p className="text-muted-foreground font-default text-lg leading-relaxed mb-6">
                  Please send your resume and a brief cover letter to RiverBend.
                  Use the role title in your email subject line so we can direct
                  your application properly.
                </p>

                <div className="bg-primary-50/70 border border-primary-100 rounded-md p-5 mb-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <p className="text-primary-500 font-default font-semibold mb-2">
                        Email
                      </p>

                      <p className="text-muted-foreground font-default">
                        employment@riverbendcorp.ca
                      </p>
                    </div>

                    <div>
                      <p className="text-primary-500 font-default font-semibold mb-2">
                        Application Timeline
                      </p>

                      <p className="text-muted-foreground font-default">
                        Open until filled
                      </p>
                    </div>
                  </div>

                  <div className="mt-6 pt-5 border-t border-primary-100">
                    <p className="text-primary-500 font-default font-semibold mb-2">
                      Subject line
                    </p>

                    <p className="text-muted-foreground font-default">
                      Application – Financial Reporting and Program Support Lead
                    </p>
                  </div>
                </div>

                <div className="bg-secondary/10 border border-secondary/20 rounded-md p-5 mb-8 flex items-start gap-3">
                  <CalendarClock className="size-5 text-secondary shrink-0 mt-0.5" />

                  <p className="text-muted-foreground font-default leading-relaxed">
                    This is a full-time, permanent role based primarily at
                    RiverBend’s Thunder Bay office. Some travel to client
                    communities may be required depending on project needs.
                  </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <a href="mailto:employment@riverbendcorp.ca?subject=Application%20-%20Financial%20Reporting%20and%20Program%20Support%20Lead">
                    <Button className="w-full sm:w-auto bg-secondary hover:bg-secondary/90 text-white font-default">
                      <Mail className="mr-2 size-5" />
                      Apply by Email
                    </Button>
                  </a>

                  <Link to="/CareerOpportunitiesPage">
                    <Button variant="outline" className="w-full sm:w-auto border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white font-default">
                      <RotateCcw className="mr-2 size-5" />
                      Back to Career Opportunities
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="min-w-0">
            <Card className="h-full border-border shadow-sm rounded-lg bg-primary-500 text-primary-foreground">
              <CardContent className="p-8 md:p-10 flex flex-col h-full">
                <p className="text-secondary-100 font-default font-bold tracking-wider uppercase text-sm mb-4">
                  Working at RiverBend
                </p>

                <h3 className="text-2xl font-default font-bold mb-5">
                  Lead meaningful files, support real progress, and help build
                  stronger systems.
                </h3>

                <div className="space-y-5 mb-8">
                  {highlights.map((item, i) => <div key={i} data-index={i} className="flex gap-4">
                      <div className="size-10 rounded-md bg-white/10 flex items-center justify-center shrink-0">
                        <item.icon className="size-5 text-secondary-100" />
                      </div>

                      <div>
                        <p className="font-default font-semibold mb-1">
                          {item.title}
                        </p>

                        <p className="text-primary-foreground/80 text-sm font-default leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>)}
                </div>

                <div className="mt-auto">
                  <Link to="/OurCommitmentToEmployeesPage">
                    <Button variant="secondary" className="w-full font-default">
                      Our Commitment to Employees
                      <ArrowRight className="ml-2 size-4" />
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}